import { loginProxy, loginProxyWithAuth } from './index';

/* [ 인증 ] */
function getAuthRSA() {
  return loginProxy.get('login/rsaKey');
}

function checkTenant(params) {
  return loginProxy.post('login/tenantCheck', params);
}

function checkUser(params) {
  // return loginProxy.post('login/userCheck', params);
  return loginProxy.post('login/mobUserCheck', params);
}

// 사용자체크 (rsa없는버전)
function checkUserNoRsa(params) {
  return loginProxy.post('login/userCheck/noRsa', params);
}

// 비밀번호 인증코드 발송
function sendPasswordOtp(params) {
  return loginProxy.post('login/password/otp/send', params);
}

// 비밀번호 인증코드 검사
function checkPasswordOtp(params) {
  return loginProxy.post('login/password/otp/check', params);
}

// 비밀번호 재설정
function resetPassword(params) {
  return loginProxy.post('login/password/reset', params);
}

// 비밀번호재설정 뷰데이터 조회 (초기비번재설정시 사용)
function getResetPasswordViewData(params) {
  return loginProxy.post('login/password/reset/viewData', params);
}

// 비밀번호 변경
function changePassword(params) {
  return loginProxyWithAuth.post('login/password/change', params);
}

// 앱 정보 저장
function postMobileInfo(params) {
  return loginProxyWithAuth.post('api/mobileInfo', params);
  // return loginProxy.post('api/mobileInfo', params);
}

// 앱 정보 조회
function getMobileInfo(params) {
  return loginProxyWithAuth.get('api/sessionData', params);
}

// 세션정보 갱신 및 반환
function postNewSession() {
  return loginProxyWithAuth.get('api/valid');
}

// 로그아웃
function logout() {
  return loginProxyWithAuth.get('login/logout');
}

// 로그인 AccessToken 확인
function checkAccessToken(params) {
  return loginProxy.post('login/tokenAuthentication', params);
}

export {
  getAuthRSA,
  checkTenant,
  checkUser,
  checkUserNoRsa,
  changePassword,
  postMobileInfo,
  getMobileInfo,
  postNewSession,
  logout,
  checkAccessToken,
  sendPasswordOtp,
  checkPasswordOtp,
  resetPassword,
  getResetPasswordViewData,
};
